import { Vue, Options } from 'vue-class-component';
import Calendar from 'primevue/calendar';

@Options({
  name: 'TimeSelectorComponent',
  components: {
    Calendar,
  },
  props: {
    modelValue: {
      type: String,
    },
    onlyMinuteSeconds: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update:modelValue'],
  watch: {
    insideValue: function (newValue) {
      if (!newValue) this.$emit('update:modelValue', '');
      if (this.isCorrectValue)
        this.$emit(
          'update:modelValue',
          this.onlyMinuteSeconds ? '00:' + newValue : newValue + ':00'
        );
    },
  },
})
export default class TimeSelectorComponent extends Vue {
  insideValue = '';
  labelPlaceholder = '';
  modelValue!: string;
  onlyMinuteSeconds!: boolean;
  get isCorrectValue() {
    const regex = this.onlyMinuteSeconds
      ? new RegExp('([0-5][0-9]):([0-5][0-9])')
      : new RegExp('([01][0-9]|2[0-3]):([0-5][0-9])');
    return this.insideValue.length === 5 && regex.test(this.insideValue);
  }

  mounted() {
    this.labelPlaceholder = this.onlyMinuteSeconds ? 'MM:SS' : 'HH:MM';
    this.insideValue =
      this.modelValue && this.onlyMinuteSeconds
        ? this.modelValue.split(/:(.+)/)[1]
        : this.modelValue;
  }
}
